import request from '@/utils/request'

//登录
export function login(data) {
  return request({
    url: '/api/web/sysUser/login',
    method: 'post',
    data:data
  })
}

//获取当前登录用户信息
export function getSysUser(data) {
  return request({
    url: '/api/web/sysUser/getSysUser',
    method: 'get',
    data,
  })
}

//修改密码
export function updatePassword(data) {
  return request({
    url: '/api/web/sysUser/updatePassword',
    method: 'post',
    data,
  })
}

//查询用户拥有的菜单和按钮权限
export function myMenuOperation(data) {
  return request({
    url: '/api/web/common/auth/myMenuOperation',
    method: 'get',
    data,
  })
}
//查询用户拥有的菜单权限
export function myMenu(data) {
  return request({
    url: '/api/web/common/auth/myMenu',
    method: 'get',
    data,
  })
}
//查询用户拥有的菜单权限
export function myMenuAndBtn(data) {
  return request({
    url: '/api/web/common/auth/myMenuAndBtn',
    method: 'get',
    data,
  })
}

